module.exports = __webpack_public_path__ + "static/media/Piercing-mouth-laterallabret.e2b7ac93.png";